import { StandardEvents } from '@shopify/events';

/**
 * LeafX product offers: copies a coupon code on tap and refreshes the offer
 * prices when the shopper picks another variant.
 */
class LeafxProductOffers extends HTMLElement {
  #abort = new AbortController();

  connectedCallback() {
    const { signal } = this.#abort;
    this.addEventListener('click', this.#onClick, { signal });
    const section = this.closest('.shopify-section');
    section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect, { signal });
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  /** @param {MouseEvent} event */
  #onClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-copy-code]') : null;
    if (!(button instanceof HTMLElement)) return;
    const code = button.dataset.copyCode || '';
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      return;
    }
    for (const el of this.querySelectorAll('[data-copied]')) el.removeAttribute('data-copied');
    button.setAttribute('data-copied', '');
    const status = this.querySelector('[data-copy-status]');
    if (status) status.textContent = (this.dataset.textCopied || '').replace('__CODE__', code);
  };

  /** @param {Event} event */
  #onProductSelect = (event) => {
    const promise = /** @type {any} */ (event).promise;
    if (!promise || typeof promise.then !== 'function') return;
    promise
      .then((/** @type {any} */ result) => {
        const html = result?.detail?.html;
        if (!html || typeof html.querySelector !== 'function') return;
        const fresh = html.querySelector(`leafx-product-offers[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.replaceWith(document.importNode(fresh, true));
      })
      .catch(() => {});
  };
}

if (!customElements.get('leafx-product-offers')) {
  customElements.define('leafx-product-offers', LeafxProductOffers);
}
